import { Observable, of, switchMap } from 'rxjs';
import { HttpClientInterface } from '@itk/http-client-interface';
import {
  CancelSubscriptionResponse,
  ManualPaymentResponse,
  IsAgency,
  PaymentInfo,
  PaymentTokens,
  PromoCodeRequest,
  PromoCodeResponse,
  UpdateSubscriptionResponse,
  UpdateSubscriptionRequest,
  DefaultCardResponse,
  DefaultCardRequest,
  DeleteCardRequest,
  DeleteCardResponse,
  AddCardResponse,
  AddCardRequest,
} from '../models/payments.model';

export class PaymentsEndpoint {
  constructor(private readonly http: HttpClientInterface) {}

  getCustomerInfo(): Observable<PaymentInfo> {
    return this.http.get<PaymentInfo>({ url: '/payments/info/' });
  }

  getPaymentTokens(): Observable<PaymentTokens> {
    return this.http.get<PaymentTokens>({ url: '/payments/tokens/' });
  }

  checkPromoCode(
    promoCodeRequest: PromoCodeRequest,
  ): Observable<PromoCodeResponse> {
    return this.http.post<PromoCodeResponse, PromoCodeRequest>({
      url: '/payments/apply-code/',
      body: promoCodeRequest,
    });
  }

  isAgency(): Observable<boolean> {
    return this.http
      .get<IsAgency>({ url: '/payments/is-agency/' })
      .pipe(switchMap((response) => of(response.is_agency)));
  }

  cancelSubscription(): Observable<CancelSubscriptionResponse> {
    return this.http.post<CancelSubscriptionResponse, object>({
      url: '/payments/cancel/',
      body: {},
    });
  }

  runManualPayment(): Observable<ManualPaymentResponse> {
    return this.http.post<ManualPaymentResponse, object>({
      url: '/payments/manual-pay/',
      body: {},
    });
  }

  updateSubscription(
    req: UpdateSubscriptionRequest,
  ): Observable<UpdateSubscriptionResponse> {
    return this.http.post<ManualPaymentResponse, UpdateSubscriptionRequest>({
      url: '/payments/subscription/',
      body: req,
    });
  }

  setDefaultCard(req: DefaultCardRequest): Observable<DefaultCardResponse> {
    return this.http.post<DefaultCardResponse, DefaultCardRequest>({
      url: '/payments/default/',
      body: req,
    });
  }

  deleteCard(req: DeleteCardRequest): Observable<DeleteCardResponse> {
    return this.http.post<DeleteCardResponse, DeleteCardRequest>({
      url: '/payments/remove/',
      body: req,
    });
  }

  addCard(req: AddCardRequest): Observable<AddCardResponse> {
    return this.http.post<AddCardResponse, AddCardRequest>({
      url: '/payments/add/',
      body: req,
    });
  }
}
